import { render, staticRenderFns } from "./IconLeftChevron.vue?vue&type=template&id=49ea01e1&"
import script from "./IconLeftChevron.vue?vue&type=script&lang=js&"
export * from "./IconLeftChevron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports